import React from "react";
import ReactDOM from "react-dom";
import "./extensions";
import "./index.css";
import "./styles/mobile.css"; // Mobile-first responsive styles
import "react-dropdown/style.css";
import App from "./App.js";
import Header from "./Header";
import "./web.config";
import { Helmet } from "react-helmet";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
const TITLE = process.env.REACT_APP_SITE_TITLE;

// if ("serviceWorker" in navigator) {
//   navigator.serviceWorker
//     .register("./firebase-messaging-sw.js")
//     .then(function (registration) {
//       console.log("Registration successful, scope is:", registration.scope);
//     })
//     .catch(function (err) {
//       console.log("Service worker registration failed, error:", err);
//     });
// }
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.render(
  <React.StrictMode>
    <Helmet>
      <title>{TITLE}</title>
    </Helmet>
    <Header />
    <QueryClientProvider client={queryClient}>
      <App />
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
    </QueryClientProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
const body = document.getElementsByTagName("body")[0];
const html = document.documentElement;
if (localStorage.langCity === "en") {
  body.setAttribute("dir", "ltr");
  body.setAttribute("lang", "en");
  html.setAttribute("dir", "ltr");
  html.setAttribute("lang", "en");
  body.classList.add("english");
} else if (!localStorage.langCity) {
  body.setAttribute("dir", "rtl");
  body.setAttribute("lang", "ar");
  html.setAttribute("dir", "rtl");
  html.setAttribute("lang", "ar");
  body.classList.add("arabic");
} else {
  body.setAttribute("dir", "rtl");
  body.setAttribute("lang", "ar");
  html.setAttribute("dir", "rtl");
  html.setAttribute("lang", "ar");
  body.classList.add("arabic");
}

if (!window.$) throw new Error("JQUERY IS REQUIRED");
